const initIntroSlider = () => {
  const root = document.querySelector('[data-intro-container]');
  if (!root) {
    return;
  }

  const container = root.querySelector('[data-intro-swiper]');
  if (!container) {
    return;
  }

  const pagination = container.querySelector('[data-intro-pagination]');


  new Swiper(container, {
    speed: 3000,
    loop: true,
    enabled: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: pagination,
      clickable: true,
    },
    breakpoints: {
      1200: {
        enabled: true,
      },
    },
    autoplay: true
    });
};

export { initIntroSlider };

